export default __webpack_public_path__ + "static/media/intellij.35c9b698.svg";